export default "__VITE_ASSET__9e8b184a__"